export default {
  getPath(user) {
    let path = '/';
    if (user.isLr && user.functionsRouteName.includes('DonorsAtWork')) {
      path = '/donorsAtWork?take=100&skip=0&orderby=desc&column=externalId';
    } else if (
      (user.isTc || user.isRdkm) &&
      user.functionsRouteName.includes('Patients')
    ) {
      path = '/patients?take=100&skip=0&orderby=desc&column=createDate';
      if (user.isRdkm) {
        path = path + '&status=2';
      }
    }

    return path;
  },

  getRedirectPath(user, currentRouteName, organizationId) {
    let path = '/';
    if(user.functionsRouteName.includes(currentRouteName) && currentRouteName != '403') {
      path = location.pathname;
      if(currentRouteName == 'UserEdit') {
        if(path.split("/").length - 1 > 2) {
          path = path.substr(0, path.lastIndexOf("/"));
        }
        if(organizationId) {
          path = path + '/' + organizationId;
        }
      }
    } else if (user.isLr && user.functionsRouteName.includes('DonorsAtWork')) {
      path = '/donorsAtWork?take=100&skip=0&orderby=desc&column=externalId';
    } else if (
      (user.isTc || user.isRdkm) &&
      user.functionsRouteName.includes('Patients')
    ) {
      path = '/patients?take=100&skip=0&orderby=desc&column=createDate';
      if (user.isRdkm) {
        path = path + '&status=2';
      }
    }

    return path;
  }
};
